import React, { useEffect, useState } from 'react';
import {
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Container,
  Divider,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Game } from '@par/shared/types/game';
import { Profile } from '@par/shared/types/player';

type ActiveSubTabs =
  | 'leaderboards'
  | 'submit-question'
  | 'starter-kits'
  | 'dailies';

type PropTypes = {};

export const SubNav = ({}: PropTypes) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    if (location.pathname.includes('/explore/leaderboards'))
      return 'leaderboards';
    if (location.pathname.includes('/explore/submit-question'))
      return 'submit-question';
    if (location.pathname.includes('/explore/starter-kits'))
      return 'starter-kits';
    if (location.pathname.includes('/explore/dailies')) return 'dailies';
  };

  const [activeSubTab, setActiveSubTab] =
    useState<ActiveSubTabs>('leaderboards');

  useEffect(() => {
    setActiveSubTab(getActiveTab);
  }, [location]);

  const SubHeaderTab = (isActiveTab: boolean, text: string) => (
    <Typography
      variant={isActiveTab ? 'subtitle2led' : 'subtitle2'}
      letterSpacing={2}
      color={!isActiveTab ? 'info.light' : null}
      sx={{
        filter: isActiveTab
          ? 'drop-shadow(0 0 15px #db3eb1) drop-shadow(0 0 50px #db3eb1) contrast(2)'
          : null,
      }}
    >
      {text}
    </Typography>
  );

  const handleLeaderboards = () => navigate('/explore/leaderboards');
  const handleSubmitAQuestionClick = () => navigate('/explore/submit-question');
  const handleStarterKitsClick = () => navigate('/explore/starter-kits');
  const handleDailiesClick = () => navigate('/explore/dailies');

  const handleSubNavChange = (event: any, tab: ActiveSubTabs) => {
    setActiveSubTab(tab);
    if (tab === 'leaderboards') handleLeaderboards();
    if (tab === 'submit-question') handleSubmitAQuestionClick();
    if (tab === 'starter-kits') handleStarterKitsClick();
    if (tab === 'dailies') handleDailiesClick();
  };

  return (
    <Container>
      <Box display={'flex'} justifyContent={'left'} mt={2}>
        <Tabs
          variant="scrollable"
          value={false}
          onChange={handleSubNavChange}
          indicatorColor="secondary"
          sx={{
            width: '100%',
            height: 0,
            borderRadius: '10px',
            bgcolor: '#190c1a',
            '& .MuiTabs-flexContainer': { height: '100%' },
          }}
        >
          <Tab
            label={SubHeaderTab(
              activeSubTab === 'leaderboards',
              'Leaderboards'
            )}
            value="leaderboards"
          />
          <Divider
            flexItem
            orientation="vertical"
            sx={{
              height: '40%',
              alignSelf: 'center',
              borderRightWidth: 2,
            }}
          />
          <Tab
            label={SubHeaderTab(
              activeSubTab === 'submit-question',
              'Submit Question'
            )}
            value="submit-question"
          />
          <Divider
            flexItem
            orientation="vertical"
            sx={{
              height: '40%',
              alignSelf: 'center',
              borderRightWidth: 2,
            }}
          />
          <Tab
            label={SubHeaderTab(
              activeSubTab === 'starter-kits',
              'Starter Kits'
            )}
            value="starter-kits"
          />
          <Divider
            flexItem
            orientation="vertical"
            sx={{
              height: '40%',
              alignSelf: 'center',
              borderRightWidth: 2,
            }}
          />
          <Tab
            label={SubHeaderTab(activeSubTab === 'dailies', 'Dailies Archives')}
            value="dailies"
          />
        </Tabs>
      </Box>
    </Container>
  );
};
